/**
 * Flag icon for a currency code, used by the amount columns that show a bill in
 * a currency other than the organisation's own. Shared so the inbox and the
 * payables tables badge foreign amounts the same way.
 */
const CURRENCY_FLAGS: Record<string, string> = {
  AUD: 'au',
  USD: 'us',
  GBP: 'gb',
  EUR: 'eu',
  NZD: 'nz',
  CAD: 'ca',
  SGD: 'sg',
  HKD: 'hk',
  JPY: 'jp',
  CNY: 'cn',
  INR: 'in',
  ZAR: 'za',
  AED: 'ae',
  CHF: 'ch',
  SEK: 'se',
  NOK: 'no',
  DKK: 'dk',
  PLN: 'pl',
  MXN: 'mx',
};

/** Empty for a currency with no flag, which the templates render as no image. */
export function currencyFlagUrl(code: string | number): string {
  if (!code) {
    return '';
  }

  const flag = CURRENCY_FLAGS[code.toString().toUpperCase()];

  return flag ? `https://flagcdn.com/16x12/${flag}.png` : '';
}
